import { Modal, RadioGroup, FormControlLabel, Radio, TextField } from '@mui/material'
import { Dispatch, SetStateAction, useState } from 'react';
import CloseIcon from "@mui/icons-material/Close";
import { Button } from "@mui/material";
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';

interface ModalProps {
  open: boolean;
  onClose: () => void;
  setOpen: Dispatch<SetStateAction<boolean>>;
}

export function CancelPauseModal({ open, onClose, setOpen }: ModalProps) {
  const [option, setOption] = useState("cancel");
  return (
    <Modal className="modal cancelPause_modal" open={open} onClose={onClose}>
      <div className="modal-dialog">
        <div className="modal-body">
          <div className="modal_title">
            <h2>Cancel / Pause Plan</h2>
            <div className="btn-close" onClick={() => setOpen(false)}>
              <CloseIcon />
            </div>
          </div>

          <form className="form">
            <div className="control_group" style={{ marginBottom: "25px" }}>
              <RadioGroup className="flex" value={option} onChange={(e) => setOption(e.target.value)}>
                <FormControlLabel value="cancel" control={<Radio />} label="Cancel Plan" />
                <FormControlLabel value="pause" control={<Radio />} label="Pause Plan" />
              </RadioGroup>
            </div>

            {option === 'pause' && (
              <div className="control_group">
                <label>Pause Until</label>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    className="form_control"
                    slots={{
                      openPickerIcon: () => <img src="/static/images/date_icon.svg" alt="icon" />,
                    }}
                    slotProps={{
                      textField: {
                        placeholder: "Select Date",
                        fullWidth: true,
                        hiddenLabel: true
                      },
                    }}
                    desktopModeMediaQuery="(min-width:0px)"
                  />
                </LocalizationProvider>
              </div>
            )}
            {option === 'cancel' && (
              <div className="control_group">
                <label>Reason for Cancellation</label>
                <TextField fullWidth hiddenLabel multiline rows={2} placeholder="Enter Reason" />
              </div>
            )}

            <div className="footer_btn_flex">
              <Button className="btn btn_grey" onClick={() => setOpen(false)}>Cancel</Button>
              <Button className="btn btn_primary" onClick={() => setOpen(false)}>Confirm</Button>
            </div>
          </form>
        </div>
      </div>
    </Modal>
  )
}